import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import { translateRestriction } from './propertyCzUtils';
import BasicRow from '../../reportSections/identData/basicRow';

import './propertyCz.scss';

class PropertyCzRealRight extends React.Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        showRestriction: PropTypes.bool
    };

    static defaultProps = {
        showRestriction: true
    };

    render() {
        const data = this.props.data;
        return (
            <div className="ident-data">
                <BasicRow title="PropertyCz.Report.OD.RestrictionName" value={data.name} />
                <BasicRow title="PropertyCz.Report.OD.RestrictionDescription" value={data.description} />
                <BasicRow title="PropertyCz.Report.OD.AuthorizationFor" value={data.authorizationFor} />
                <BasicRow title="PropertyCz.Report.OD.LiabilityFor" value={data.liabilityFor} />
                <BasicRow title="PropertyCz.Report.OD.Document" value={data.document} />
                <BasicRow title="PropertyCz.Report.OD.DocumentNumber" value={data.documentNumber} />
                <BasicRow title="PropertyCz.Report.OD.OrderTo" value={data.orderTo} />
                {this.props.showRestriction && <BasicRow title="PropertyCz.Report.OD.Restriction" value={translateRestriction(data.restriction, this.props.translate)} />}
            </div>
        );
    }
}

export default withLocalize(PropertyCzRealRight);